import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

const SiblingDialog = ({ open, onClose }) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} disableEscapeKeyDown maxWidth="sm">
            <DialogTitle>
                {t("Sibling Priority Information")}
            </DialogTitle>
        <DialogContent dividers>
            <Typography variant="body1" gutterBottom>
                {t("If you answer “Yes,” your child may get priority in the lottery. This does not guarantee a seat.")}
            </Typography>

            <Typography variant="h6" mt={2}>{t("Who counts as a brother or sister")}</Typography>
            <List dense>
                <ListItem><ListItemText primary={t("✔ Lives in the same home")} /></ListItem>
                <ListItem><ListItemText primary={t("✔ Step-brothers/sisters living with you")} /></ListItem>
                <ListItem><ListItemText primary={t("✔ Foster children living with you")} /></ListItem>
            </List>

            <Typography variant="h6" mt={2}>{t("Who does not count")}</Typography>
            <List dense>
                <ListItem><ListItemText primary={t("❌ Cousins")} /></ListItem>
                <ListItem><ListItemText primary={t("❌ Friends")} /></ListItem>
                <ListItem><ListItemText primary={t("❌ Brothers or sisters in a different iLearn school")} /></ListItem>
                <ListItem><ListItemText primary={t("❌ An alumnus of the school with a sibling applying for the following year")} /></ListItem>
            </List>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} variant="contained">
                {t("Got it")}
            </Button>
        </DialogActions>
    </Dialog>
)}

export default SiblingDialog;